import type { CSSProperties } from 'react'
import { Text, Tooltip } from '@common/ui'
import { ActionsBreakdown } from '../../domain/permission/computeActionsBreakdown'

const cellContainerStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
}

export const NoneText = () => (
  <Text size="sm" lh={1.3} py="xxs" c="var(--trellis-color-text-disabled)" fs="italic">
    none
  </Text>
)

export const StringListCell = ({ value }: { value: string[] | undefined }) => {
  if (!value || value.length === 0) return <NoneText />
  const text = value.join(', ')
  return (
    <Tooltip label={text} position="top-start">
      <div style={cellContainerStyle}>
        <Text size="sm" lh={1.3} truncate>
          {text}
        </Text>
      </div>
    </Tooltip>
  )
}

export const TypesPermissionsCell = ({ value }: { value: ActionsBreakdown['perType'] | undefined }) => {
  if (!value || value.length === 0) return <NoneText />
  const lines = value.map((entry) => `${entry.typeName}: ${entry.labels.join(', ')}`)
  return (
    <Tooltip
      label={<div style={{ whiteSpace: 'pre-line' }}>{lines.join('\n')}</div>}
      position="top-start"
      multiline
      maw={400}
    >
      <div style={cellContainerStyle}>
        <Text size="sm" lh={1.3} truncate>
          {value.map((entry, idx) => (
            <span key={entry.typeName}>
              {idx > 0 ? ' · ' : ''}
              <span style={{ fontWeight: 600 }}>{entry.typeName}:</span> {entry.labels.join(', ')}
            </span>
          ))}
        </Text>
      </div>
    </Tooltip>
  )
}
